import React, { useEffect } from "react";
import {
  IoIosArrowRoundBack,
  IoIosArrowRoundForward,
  IoIosPersonAdd,
} from "react-icons/io";
import { RotatingLines } from "react-loader-spinner";
import { Link } from "react-router-dom";
import ExportData from "../../../components/ExportData";

const PrintCashierSalesReport = ({ 

  totalSales, cashierSales, getCashierSales, getTableData,fileName, tableData, search, setSearch, currentPage, setCurrentPage, nextPage, prevPage, totalPages, loading, pageSize, setPageSize 
}) => {
  const filterSalesList = (search_query) => {
    setSearch(search_query);
    setCurrentPage(1); // Reset to page 1 whenever search query changes
  };

  const handleNextPage = () => {
    if (nextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (prevPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalNumbersToShow = 3; // Number of pages to show around the current page
    const totalPagesToShow = 5; // Total pages to show at start and end

    let startPage = Math.max(1, currentPage - totalNumbersToShow);
    let endPage = Math.min(totalPages, currentPage + totalNumbersToShow);

    // Always show the first page
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Show the numbers around the current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Always show the last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((number) => (
      <button
        key={number}
        onClick={() => number !== "..." && handlePageClick(number)}
        className={
          number === currentPage
            ? "border border-[#979797] bg-gradient-to-b from-white to-[#dcdcdc] py-[0.5rem] px-[1rem]"
            : "py-[0.5rem] px-[1rem]"
        }
      >
        {number}
      </button>
    ));
  };

  useEffect(() => {
    getCashierSales(pageSize, search, currentPage);
    getTableData(pageSize, search, currentPage);
  }, [search, currentPage, pageSize]);

  return (
    <div className="p-[20px]">
      <div className="border border-[#ddd] bg-white">
        <div className="p-[20px]">
          <h5 className="my-[2px] text-[17px]">Sales Report</h5>
        </div>
        <div className="p-[20px]">
          <div className="p-[20px] border border-[#ddd]">
            <div className="pt-[20px] flex justify-between mb-[20px]">
              <div className=" flex items-center gap-5">
                <ExportData tableData={tableData} fileName={fileName} />
                <div className="flex items-center gap-2">
                  <b>Show:</b>
                  <select
                    name=""
                    id=""
                    onChange={(e) => setPageSize(e.target.value)}
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <b>Filter:</b>
                <input
                  type="text"
                  placeholder="Type to filter..."
                  onChange={(e) => filterSalesList(e.target.value)}
                  className="outline-none border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                />
              </div>
            </div>

            <div className="overflow-auto ">
              <table className="border-collapse w-full">
                <thead>
                  <tr className="text-left">
                    <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                      Drug Name
                    </th>
                    <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                      Quantity Sold
                    </th>
                    <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                      Unit Price
                    </th>
                    <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                      Cash Sales
                    </th>
                    
                    <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                      Date
                    </th>
                  </tr>
                </thead>
                {!loading && (
                  <tbody>
                    {cashierSales?.map((sale, index) => (
                      <tr className="text-left" key={index}>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.drug}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.quantity}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.unit_cost}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.total_selling_price}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.created_at}
                        </td>
                      </tr>
                    ))}
                    <tr className="font-bold">
                      <td colSpan={3} className="border-b border-[#bbb] py-[12px] px-[20px]">
                        Total Sales
                      </td>
                      <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                        {totalSales}
                      </td>
                      <td className="border-b border-[#bbb] py-[12px] px-[20px]"></td>
                    </tr>
                  </tbody>
                )}
              </table>
              {loading && (
                <div className="flex items-center justify-center py-10">
                  <RotatingLines
                    visible={true}
                    height="30"
                    width="30"
                    color="black"
                    strokeColor="black"
                    strokeWidth="5"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                </div>
              )}
              {cashierSales?.length <= 0 && !loading && (
                <p className="text-center py-5">No data availabe in table</p>
              )}
              <div className="flex justify-between pt-[20px]">
                <p className="text-[12px] text-[#888]">
                  Showing {currentPage} of {totalPages} pages
                </p>
                <div className="flex items-center gap-2">
                  <IoIosArrowRoundBack
                    className="text-[25px]"
                    onClick={handleNextPage}
                  />
                  {renderPageNumbers()}
                  <IoIosArrowRoundForward
                    className="text-[25px]"
                    onClick={handlePreviousPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        .
      </div>
    </div>
  );
};

export default PrintCashierSalesReport;
